import { Injectable } from '@angular/core';
import { ServiceService } from './service.service';

@Injectable({
  providedIn: 'root'
})
export class NormatividadService {
  constructor(private servi: ServiceService) {  }
  public getListado(id) {
    return this.servi.get('normatividad/listadoNormas/'+id);
  }
  public crearNorma(data) {
      return this.servi.post(data,'normatividad/crearNorma' );
  }
  public cambiarEstadoN(id){
    return this.servi.get('normatividad/cambiarEstado/'+id);
  }
  public publicarOcultarN(id){
    return this.servi.get('normatividad/publicarOcultar/'+id);
  }
  public getDatosSelect() {
    return this.servi.get('normatividad/getDatosSelect');
  }
  public guardarNorma(norma) {
    return this.servi.postFile('normatividad/guardarNorma', norma);
  }
  public editarNorma(norma){
    return this.servi.postFile('normatividad/editarNorma', norma);
  }
  public getDetalleNorma(id){
    return this.servi.get('normatividad/detalleNorma/'+id);
  }
  public getTipoNorma(id){
    return this.servi.get('normatividad/getTipoNorma/'+id);
  }
  public getServe(){ 
    return this.servi.server; 
  }
  public getNorma(id){
    return this.servi.get('normatividad/getNorma/'+id);
  }
  public getListadoNormaExterna(){
    return this.servi.get('normatividad/getListadoNormaExterna');
  }
  public guardarDetalleNorma(detalleNorma) {
      return this.servi.postFile('normatividad/guardarDetalleNorma', detalleNorma);

  }
  public getDetalleHTMLNorma(id){
    return this.servi.postFile('normatividad/getDetalleHTMLNorma', id);
  }
}
